export const displayName = (item, lang) =>
  lang === 'ar' && item?.arabicName ? item.arabicName : (item?.name ?? '');
